/* eslint-disable no-mixed-spaces-and-tabs */
import React from 'react';
import './Filters.css';
import MultiSelectBox from '../Filters/MultiSelectBox/MultiSelectBox';
import Dropdowns from '../Filters/Dropdowns/Dropdowns';
import Searchinput from '../../Components/Search/Search';
import RoomDisplayToggle from '../Filters/RoomDisplayToggle/roomDisplayToggle';

export default (props) => {
	return (
		<div className="filters">
			<Searchinput searchOnChange={props.searchOnChange} searchable={props.searchable} />


			{props.RoomDisplayToggle.map((item, index) => {
				return (
					<RoomDisplayToggle   key={index + "doublePoo"} onChange={item.onChange} />
				);
			})
			}


			{props.multiSelectBoxes.map((item, index) => {
				return (

					<MultiSelectBox key={index + "howdy"} boxClassName={item.filterClass} boxLabel={item.label} items={item.items} onChange={item.onChange} />
				);
			})
			}

			{props.Dropdowns.map((item, index) => {
				return (

				  <Dropdowns key={index + "poo"} filterClassName={item.filterClass} selectLabel={item.label} items={item.items} selectLabelHeader="true" onChange={item.onChange} activeDropdown={item.activeDropdown} defaultValue={item.defaultValue} />
				);
			})
			}
			{props.children}

		</div>
	);
};




// WEBPACK FOOTER //
// ./src/Components/Filters/index.js